import axios from "../axios/axios";
import { setPricePlans, setPrices, setProducts } from "../store/actions/productAction";
import { apiSetAlert } from "./appApi";
import { appCloseModal, appSetAlert, appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { selectTableItems } from "../store/actions";
import { resetForm, setAction, setEditItem, setIndex, updateFormStatus } from "../store/actions/formAction";
import { setFormData } from "../helpers/FormDataCreator";
import { errorDispatcher, getOptionsQuery, setSelectItemLabels } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetProductsExcel = (token, productType, selectedIds) => (dispatch, getState) => {
  let url = `products/excel/export?isProduct=${productType === "product" ? "1" : "0"}`;
  if (selectedIds && selectedIds.length > 0) {
    url += `&ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading(true));
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_")
      const fileName = productType ? `${productType}s_${now}` : `products_${now}`;
      fileDownload(response.data, `${fileName}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProduct = (productId, token) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`products/${productId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const data = response.data.product;
      const editItem = { ...data.main, ...data.others };
      dispatch(setEditItem(editItem));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProductWithBarcode = (barcode, token, callback) => (dispatch, getState) => {
  axios
    .get(`products/barcode?barcode=${barcode}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback(response.data.products[0] ?? null);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProductList = ({ token, key = "product", callBack, type }) =>
  (dispatch, getState,) => {
    let url = "/products/list/active";
    dispatch(appSetLoading(true));
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: { type: type || "all", productType: key },

      })
      .then((response) => {
        const product = setSelectItemLabels(response.data.products, "id", "title");
        callBack(product)
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });

  }
export const apiGetProducts =
  ({ pagination, token, key = "product", sort, search, callBack = (res) => { } }) =>
    (dispatch, getState) => {
      let isProduct = key === "service" ? 0 : 1;

      let url = "/products/list";
      let options = getOptionsQuery(pagination, search, sort);
      options.isProduct = isProduct;

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const products = setSelectItemLabels(response.data.products, "id", "title");
          if (!pagination?.notTable) dispatch(setTableData(response.data.products, response.data.paginate));
          if (callBack) callBack(products)
          // dispatch(setProducts(products, isProduct));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiProductsList = (props) => (dispatch, getState) => {
  const { token, type, cb, pricePlanId } = props;
  dispatch(appSetLoading(true));
  axios
    .get(`/products/list/active`, {
      headers: { Authorization: `Bearer ${token ?? props}` },
      params: { type: type ? type : "all", pricePlanId: pricePlanId ? pricePlanId : null },
    })
    .then((response) => {
      const products = setSelectItemLabels(response.data.products, "id", "title");
      dispatch(setProducts(products, 1, false, true));
      dispatch(appSetLoading(false));
      cb && cb(products);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiProductsListByPageNumber = (props) => (dispatch, getState) => {
  const { type, cb, pricePlanId, page, limit = 100 } = props;
  const token = getState().businessReducer.business?.token;

  // dispatch(appSetLoading(true));
  axios
    .get(`/products/list/active`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type: type ? type : "all", pricePlanId: pricePlanId ? pricePlanId : null, page },
    })
    .then((response) => {
      const products = setSelectItemLabels(response.data.products, "id", "title");
      // dispatch(setProducts(products, 1, false, true));
      // dispatch(appSetLoading(false));
      cb && cb(products);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDeleteProducts = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  const productIds = selectedIds;
  dispatch(appSetLoading(true));
  dispatch(appSetSendingRequest());

  axios
    .delete(`/products/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { productIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddProducts = (forms, token, navigate, modalProps) => (dispatch, getState) => {
  const productProperty = forms[0].main?.productProperty
  if (productProperty && Array.isArray(productProperty) && productProperty.length > 0) {
    const arr = []
    for (const element of productProperty) {
      const newForms = [...forms]
      const main = { ...newForms[0].main }
      const others = { ...newForms[0].others }
      const index = newForms[0].index
      delete main.productProperty
      main.productProperties = element.id.map(x => { return { id: x } })
      main.productGroupTitle = main.title
      main.title += ` ${element.value}`
      const newData = { main, others, index }

      arr.push(newData)
    }
    dispatch(appSetSendingRequest(true));
    dispatch(setAction("save"));
    apiAddProduct(dispatch, arr, token, 0, navigate, modalProps);
  } else {
    dispatch(appSetSendingRequest(true));
    dispatch(setAction("save"));
    apiAddProduct(dispatch, forms, token, 0, navigate, modalProps);

  }

};

export const apiAddProduct = (dispatch, forms, token, index, navigate, modalProps, errorIndex = null) => {
  let form = { ...forms[index] };

  const nextApi = (res) => {
    if (index + 1 < forms.length) {
      apiAddProduct(dispatch, forms, token, index + 1, navigate, modalProps, errorIndex);
    } else {
      dispatch(appSetSendingRequest(false));
      if (errorIndex !== null) {
        dispatch(setAction("filling"));
        dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
        dispatch(setIndex(forms[errorIndex].index));
      } else {
        dispatch(apiSetAlert("محصولات و خدمات با موفقیت ثبت شدند", "success", !!modalProps));
        if (modalProps) {
          dispatch(appCloseModal());
          dispatch(resetForm());
          if (res) {
            modalProps.onFinish(token, res);
          } else {
            dispatch(modalProps.onFinish(token));
          }
        } else {
          const type = forms[forms.length - 1].others.formType;
          navigate("/products", {
            state: { type },
          });
        }
      }
    }
  };

  if (form.status !== "saved") {
    dispatch(setIndex(form.index));
    dispatch(updateFormStatus("saving"));

    // barcode auto generate
    const barcode = form?.main?.barcode;
    const code = form?.main?.code;
    if (barcode && barcode === "auto") {
      form.main.barcode = null;
      form.main.barcodeAuto = true;
    }
    if (code && code === "auto") {
      form.main.code = null;
      form.main.codeAuto = true;
    }
    if ((form.main.subUnit !== "" || form.main.subUnit !== undefined) && form.main.subUnit && !form.main.conversionRatio) {
      dispatch(apiSetAlert("ضریب تبدیل را وارد نمایید", "error"));

      return dispatch(updateFormStatus("error", "ضریب تبدیل را وارد نمایید"));
    }
    const formData = setFormData(form);
    axios
      .post("/products", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        dispatch(updateFormStatus("saved"));
        nextApi(response.data?.product);
      })
      .catch((error) => {
        errorIndex = index;
        dispatch(updateFormStatus("error", error.response.data.message ?? error.response));
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiUpdateProduct = (productId, form, token, navigate) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  const formData = setFormData(form);
  if ((form.main.subUnit !== "" || form.main.subUnit !== undefined) && form.main.subUnit && !form.main.conversionRatio) {
    dispatch(apiSetAlert("ضریب تبدیل را وارد نمایید", "error"));

    return dispatch(updateFormStatus("error", "ضریب تبدیل را وارد نمایید"));
  }
  axios
    .put(`products/${productId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/products");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddProductsExcel = (forms, token, callback) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  apiAddProductExcel(dispatch, forms, token, 0, callback);
};

export const apiAddPriceListExcel = (forms, token, callback) => {
  return (dispatch, getState) => {
    const priceList = forms.map(x => x.main)
    const data = { priceList }
    dispatch(
      apiSetProductPriceList(token, data, (res) => {

        if (res.data.status == 404) {
          const withoutError = forms.map(x => { x['status'] = "error"; return x })
          callback(forms)

        } else {
          const withoutError = forms.map(x => { x['status'] = "saved"; return x })
          callback(withoutError)
        }

      })
    );

  }
}

export const apiAddProductExcel = (dispatch, forms, token, index, callback) => {
  const form = forms[index];
  const nextApi = () => {
    if (index + 1 < forms.length) {
      apiAddProductExcel(dispatch, forms, token, index + 1, callback);
    } else {
      dispatch(appSetSendingRequest(false));
      callback(forms);
    }
  };

  if (form && form.status !== "saved") {
    form.status = "saving";

    const formData = setFormData(form);
    axios
      .post("/products", formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        form.status = "saved";
        nextApi();
      })
      .catch((error) => {
        form.status = "error";
        form.error = error.response?.data?.message ?? "";
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiGetPricePlans = (token) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`/pricePlans`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      let pricePlans = response.data.Price_plans.map((x) => ({ ...x, ind: x.id }));
      pricePlans = pricePlans.map((plan) => {
        const x = plan.Currency;
        if (!x) return plan;
        let en = x.en_title;
        let fa = x.fa_title;
        if (x.id === 1) {
          en = "IRR";
          fa = "ریال ایران";
        }
        return { ...plan, currency: { ...x, label: `( ${fa} - ${en} )`, value: x.id } };
      });
      dispatch(setPricePlans(pricePlans));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddPricePlan =
  ({ token, data, cb }) =>
    (dispatch) => {
      dispatch(appSetLoading(true));
      axios
        .post(`/pricePlans`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (cb) cb(response);
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiUpdatePricePlan =
  ({ token, data, params, cb }) =>
    (dispatch, getState) => {
      dispatch(appSetLoading(true));
      axios
        .put(`/pricePlans/${params.id}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (cb) cb(response);
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiDeletePricePlans =
  ({ token, data, cb }) =>
    (dispatch, getState) => {
      dispatch(appSetLoading(true));
      axios
        .delete(`/pricePlans`, {
          headers: { Authorization: `Bearer ${token}` },
          data,
        })
        .then((response) => {
          if (cb) cb(response);
          dispatch(appSetAlert(response.data.message));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiProductPriceListExcel = (token, cb) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`/products/priceplan/excel/export`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {

      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_")
      const fileName = `pricePlaneProduct${now}`;
      fileDownload(response.data, `${fileName}.xlsx`);
      cb(response``)
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });

}
export const apiProductPriceList = (token, cb) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`/products/productPriceList`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const products = setSelectItemLabels(response.data.products, "id", "title");
      let prices = [];
      for (const product of products) {
        if (product.Price_Plan_Products) {
          prices = [...prices, ...product.Price_Plan_Products];
        }
        if (product.sellPrice) {
          prices = [...prices, { PricePlanId: "sellPrice", ProductId: product.id, price: product.sellPrice }];
        }
        if (product.buyPrice) {
          prices = [...prices, { PricePlanId: "buyPrice", ProductId: product.id, price: product.buyPrice }];
        }
      }
      dispatch(setPrices(prices));
      if (cb) cb({ products, prices });
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiChangePriceListSpeed = (id, { changeType, changeValue, changeValueType }, cb) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  const data = { changeType, changeValue, changeValueType }
  const token = getState().businessReducer.business?.token;

  axios
    .put(`/pricePlans/updateList/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiProductPriceList(token))
      if (cb) cb(response);

      dispatch(appSetAlert(response.data.message, "success"));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });

}
export const apiSetProductPriceList = (token, data, cb) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .post(`/products/PriceList`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (cb) cb(response);

      dispatch(appSetAlert(response.data.message, "success"));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetPriceItem = (token, data, cb) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  const params = { priceList: data }
  axios
    .post(`/products/priceListItem/price`, params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (cb) cb(response);
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
